import Lottie from 'lottie-react';

import lottieTreatmentPlanEmpty from '../jsons/treatment-plan-empty.json';

const LottieTreatmentPlanEmpty = props => {
  return <Lottie animationData={lottieTreatmentPlanEmpty} loop={false} {...props} />;
};

export default LottieTreatmentPlanEmpty;
